if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        console.log("media-gallery connected");
        this.mainSwiperEl = this.querySelector(".product__gallery-main");
        this.thumbsSwiperEl = this.querySelector(".product__gallery-thumbs");
        const isQuickView = this.closest("#quick-view");
        if (!isQuickView) {
          this.initializeSwiperInstances();
        }
      }

      disconnectedCallback() {
        if (!this.mainSwiperEl) return;
        this.mainSwiperEl.swiper.destroy();
      }

      initializeSwiperInstances() {
        if (!this.mainSwiperEl) return;
        console.log("initializeSwiperInstances");

        if (this.thumbsSwiperEl) {
          const thumbsSwiperContainer = this.querySelector(".product__gallery-thumbs-container");
          this.thumbsSwiperParams = {
            direction: "vertical",
            slidesPerView: 4,
            slidesPerGroup: 1,
            slideToClickedSlide: true,
            spaceBetween: 16,
            setWrapperSize: true,
            on: {
              init() {
                thumbsSwiperContainer.classList.add("swiper-initialized");
              },
            },
          };
          Object.assign(this.thumbsSwiperEl, this.thumbsSwiperParams);
          this.thumbsSwiperEl.initialize();
        }

        const onMainGalleryChange = this.onMainGalleryChange.bind(this);
        const mainSwiperContainer = this.querySelector(".product__gallery-container");
        const isQuickView = this.closest("#quick-view");
        const thumbsParams = this.thumbsSwiperEl ? { swiper: this.thumbsSwiperEl, autoScrollOffset: 1 } : false;
        const paginationParams = isQuickView ? "bullets" : false;
        this.mainSwiperParams = {
          navigation: {
            prevEl: ".product__gallery-nav--prev",
            nextEl: ".product__gallery-nav--next",
          },
          thumbs: thumbsParams,
          slidesPerView: 1,
          slidesPerGroup: 1,
          simulateTouch: false,
          rewind: true,
          effect: "slide",
          speed: 500,
          pagination: {
            type: "progressbar",
            el: ".product__gallery-scrollbar",
          },
          breakpoints: {
            749: {
              effect: "fade",
              fadeEffect: {
                crossFade: true,
              },
            },
          },
          on: {
            init() {
              mainSwiperContainer.classList.add("swiper-initialized");
            },
            slideChange() {
              onMainGalleryChange();
            },
          },
        };

        Object.assign(this.mainSwiperEl, this.mainSwiperParams);
        this.mainSwiperEl.initialize();
      }

      setVariantMedia(imageSrc, aspectRatio) {
        const targetElMain = this.querySelector(".product__media-item:first-of-type img");
        const targetElLightboxTrigger = this.querySelector(
          ".product__media-item:first-of-type [data-lightbox-trigger]"
        );
        const targetElThumb = this.querySelector(".product__media-thumbnail:first-of-type img");
        if (!imageSrc || !targetElMain) return;
        targetElMain.src = imageSrc;
        targetElMain.dataset.thumbnail = `${imageSrc}&width=300 300w`;
        targetElMain.srcset = `${imageSrc}&width=1000 1000w`;
        targetElLightboxTrigger.href = `${imageSrc}&width=2048 2048w`;
        targetElLightboxTrigger.dataset.pswpHeight = Math.round(2048 / aspectRatio);
        if (!targetElThumb) return;
        targetElThumb.src = imageSrc;
        targetElThumb.srcset = `${imageSrc}&width=100 100w`;
      }

      onMainGalleryChange() {
        const adjustedIndex = this.mainSwiperEl.swiper.activeIndex + 1;
        const activeSlideEl = this.mainSwiperEl.querySelector(`swiper-slide:nth-of-type(${adjustedIndex})`);
        this.playActiveMedia(activeSlideEl);
      }

      playActiveMedia(activeItem) {
        if (!activeItem) return;
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) {
          deferredMedia.playMedia();
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }
    }
  );
}
